<template>
	<div>
		<el-row>
			<el-col>
				<el-form :inline='true'>
<!--					<el-form-item label="关键字:">-->
<!--						<el-input style="width:200px;" v-model="filters.keyword" @input="(e) => (filters.keyword = utils.validForbid(e))" placeholder="关键字" clearable></el-input>-->
<!--					</el-form-item>-->
<!--					<el-form-item label="所属上级:">-->
<!--						<el-cascader :key="isResouceShow" placeholder="请选择所属上级" @change="changeSearchParent"-->
<!--						             :options="options" :props="{ checkStrictly: true, value: 'id', label: 'name' }"-->
<!--						             clearable></el-cascader>-->
<!--					</el-form-item>-->
					<el-form-item>
						<toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
					</el-form-item>
				</el-form>
			</el-col>
		
		</el-row>
		<!-- 列表 -->
		<el-table :data="tableData" border style="width: 100%" v-loading="listLoading" ref="multipleTable"
		          @current-change='currentChange' :highlight-current-row='true' :cell-style="rowClass">
			<el-table-column type='index' label="序号" width='60' align="center" :index='indexMethod'></el-table-column>
			<el-table-column prop="sourceStandardName" label="原规范名" align="center" width="" show-overflow-tooltip></el-table-column>
			<el-table-column prop="sourceStandardItemName" label="原条文内容" align="center" width="" show-overflow-tooltip></el-table-column>
			<el-table-column prop="sourceSerialNumber" label="所选条文" align="center" width="" show-overflow-tooltip></el-table-column>
			<el-table-column prop="similarStandardName" label="相似规范名" align="center" width="" show-overflow-tooltip></el-table-column>
			<el-table-column prop="similarStandardItemName" label="相似规范内容" align="center" width="" show-overflow-tooltip></el-table-column>
			<el-table-column prop="similarSerialNumber" label="相似条文" align="center" width="" show-overflow-tooltip></el-table-column>
		</el-table>
		<!--底部工具条-->
<!--		<el-col :span="24" class="pageBar">-->
<!--			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"-->
<!--			               :current-page="pages.pageIndex" :page-sizes="pages.pageArr" :page-size="pages.pageSize"-->
<!--			               layout="total, sizes, prev, pager, next, jumper" :total="pages.dataCount">-->
<!--			</el-pagination>-->
<!--		</el-col>-->
		
		<!-- 新建弹窗 -->
		<el-dialog :title="dialogTitle" :visible.sync="addDialogShow" v-model="addDialogShow"
		           :close-on-click-modal="false" width='80%'>
			<el-form :model="addForm" :rules="addRules"  ref="addFormRef" label-width="160px" style='min-width:800px;display: flex;justify-content: space-between;' :inline="true">
				<el-form-item label="建筑设计防火规范:" prop="parentId" style="width: 50%">
						<el-cascader
								clearable
								filterable
								ref="originalCascader"
                style="width: 80%"
	             v-model="addForm.original"
	             @change="changeStandardItem"
	             :options="options"
	             :props="{ value: 'id', label: 'bn', children: 'children', checkStrictly: true, level: 0 }">
									<template slot-scope="{ node, data }">
										<el-tooltip class="tooltip" effect="dark" style="max-width: 200px"
										            :content="node.level === 1 ? data.content : data.content" placement="bottom">
											<span v-if="node">{{ data.content.slice(0, 30) }}</span>
										</el-tooltip>
									</template>
						</el-cascader>
				</el-form-item>
				<el-form-item label="建筑防火通用规范:" prop="parentId" style="width: 50%">
					<el-cascader
							ref="similarCascader"
							clearable
							filterable
							style="width: 100%"
							v-model="addForm.similar"
							@change="changeStandardSimilarItem"
							:options="optionsSimilar"
							:props="{ value: 'id', label: 'bn', children: 'children', checkStrictly: true, level: 0 }">
						<template slot-scope="{ node, data }">
							<el-tooltip class="tooltip" effect="dark" style="max-width: 200px"
							            :content="node.level === 1 ? data.content : data.content" placement="bottom">
								<span v-if="node">{{ data.content.slice(0, 30) }}</span>
							</el-tooltip>
						</template>
					</el-cascader>
				</el-form-item>
   
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addDialogClose">取消</el-button>
				<el-button type="primary" @click="addSubmit" :loading="addLoading">确认</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import util from "../../../util/date";
import Toolbar from "../../components/Toolbar";
import { getButtonList } from "../../promissionRouter";
import {
	getAuditContentTreeList,
	getAuditContentById,
	addAuditContent,
	updateAuditContent,
	deleteAuditContent,
	getDrStandardItemRelationList,
	getDrStandardItemList,
	deleteDrStandardItemRelation,
	addDrStandardItemRelation
} from '@/api/api'

export default {
	components: { Toolbar },
	data() {
		return {
			optionsSimilar:[],
			tooltipContent:undefined,
			utils: '',
			buttonList: [],
			isResouceShow: false,
			needData: '',
			filters: {
				keyword: '',
				parentId: undefined
			},
			tableData: [],
			listLoading: false,
			//关于分页的obj
			pages: {
				pageSize: 20,//默认每页条数
				pageArr: [10, 20, 30, 40],//默认每页条数选择
				pageIndex: 1, //默认进入页
				dataCount: 20, //默认总页数
			},
			// 新建
			addDialogShow: false,
			addLoading: false,
			dialogTitle: '',
			addForm: {
				similar:undefined,//相似
				original:undefined,//原来
			},
			addRules: {
				original: [{ required: true, message: '请选择数据', trigger: 'change' }],
				similar: [{ required: true, message: '请选择数据', trigger: 'change' }],
			},
			options: [],
			parentIdArr: [],
			similarData: [],
			originalData: [],
		}
	},
	watch: {
	
	},
	created() {
		this.utils = util
		let routers = window.localStorage.router
				? JSON.parse(window.localStorage.router)
				: [];
		this.buttonList = getButtonList(this.$route.path, routers);
		this.getDataList();
	},
	methods: {
		// 选择条文子项
		changeStandardItem(data) {
			this.originalData = this.$refs.originalCascader.getCheckedNodes();
			console.log(this.originalData,'yuanguifan')
		},
		// 选择条文子项
		changeStandardSimilarItem(data) {
			this.similarData = this.$refs.similarCascader.getCheckedNodes();
			console.log(this.similarData,'相似')
		},
		treeToList(list) {
			let res = []
			for (const item of list) {
				const { children, ...i } = item
				if (children && children.length) {
					res = res.concat(this.treeToList(children))
				}
				res.push(i)
			}
			return res
		},
		getListData(){
			this.pages.pageIndex=1;
			this.getDataList()
		},
		callFunction(item) {
			if(item.func == "getDataList") {
				this.pages.pageIndex = 1
			}
			this[item.func].apply(this, item);
		},
		getOptions() {
			this.options = [];
			this.isResouceShow = false;
			let params = {
				pageIndex:1,
				pageSize: 1000,
				standardId:29,
			}
			getDrStandardItemList(params).then(res => {
				if (res.data.success) {
					const result = res.data.response.data
				 result.forEach((item, index) => {
						let obj = JSON.parse(item.content);
						obj[0].content = obj[0].bn
						this.options.push(obj[0]);
						item.disabled = true
					})
					console.log(this.options,'options')
					this.removeChildren(this.options);
					
					this.isResouceShow = true;
				}
			})
		},
		getOptionsSimilar() {
			this.optionsSimilar = [];
			this.isResouceShow = false;
			let params = {
				pageIndex:1,
				pageSize: 1000,
				standardId:58,
			}
			getDrStandardItemList(params).then(res => {
				if (res.data.success) {
					const result = res.data.response.data
					result.forEach((item, index) => {
						let obj = JSON.parse(item.content);
						obj[0].content = obj[0].bn
						this.optionsSimilar.push(obj[0]);
						item.disabled = true
					})
					console.log(this.options,'options')
					this.removeChildren(this.optionsSimilar);
					
					this.isResouceShow = true;
				}
			})
		},
		// 把children为空的去掉
		removeChildren(list) {
			list.forEach(item => {
				if(item.children && item.children.length>0){
					this.removeChildren(item.children)
				}else if(item.children.length === 0){
					item.children = undefined;
				}else{
					item.children = undefined;
				}
			})
		},
		// 选择查询所属上级
		changeSearchParent(data) {
			this.filters.parentId = data[data.length - 1];
		},
		// 选择新增修改所属上级
		changeParent(data) {
			this.addForm.parentId = data[data.length - 1];
		},
		// 获取所属上级
		getParentArr(parentId) {
			let res = this.options.filter(item => {
				return item.id === parentId
			})
			this.parentIdArr = [res[0].id]
		},
		// 列表查询接口
		getDataList() {
			let params = {}
			this.listLoading = true
			getDrStandardItemRelationList(params).then(res => {
				if (res.data.success) {
					this.tableData = res.data.response;
				}
				this.listLoading = false
			})
		},
		// 新建
		handleAdd() {
			this.addDialogShow = true;
			this.addLoading = false;
			this.dialogTitle = '新增';
			this.parentIdArr = [];
			this.getOptions()
			this.getOptionsSimilar()
			this.addForm = {
				similar:undefined,//相似
				original:undefined,//原来
			}
		},
		addDialogClose() {
			this.addDialogShow = false;
			this.addForm = {
				similar:undefined,//相似
				original:undefined,//原来
			}
		},
		// handleEdit() {
		// 	if (!this.needData.id) {
		// 		this.$message({
		// 			message: '请选择一条数据',
		// 			type: "error"
		// 		});
		// 		return
		// 	}
		// 	getAuditContentById({ id: this.needData.id }).then(res => {
		// 		if (res.data.success) {
		// 			const { response: data } = res.data;
		// 			this.addDialogShow = true;
		// 			this.addLoading = false;
		// 			this.dialogTitle = '编辑';
		// 			this.addForm = {
		// 				id: this.needData.id,
		// 				name: data.name,
		// 				parentId: data.parentId,
		// 			}
		// 			this.getParentArr(data.parentId);
		// 		}
		// 	})
		// },
		findProperty(obj, targetProperty) {
			let values = [];
			function traverse(node) {
				if (node.hasOwnProperty(targetProperty)) {
					values.push(node);
					if (node[targetProperty]){
						traverse(node[targetProperty])
					}
				}
				
			}
			traverse(obj);
			console.log(values,'valuessssssss')
			return values;
		},
		// 新建提交
		addSubmit() {
			console.log(this.addForm,'addform')
			console.log(this.parentIdArr,'addfo1111111rm')
			this.$refs.addFormRef.validate((valid) => {
				if (valid) {
					this.addLoading = true
					const original = this.findProperty(this.originalData[0],'parent')
					const similar = this.findProperty(this.similarData[0],'parent')
					console.log(original,'original2222222222')
						let params = {
							sourceStandardId:29,//
							sourceStandardItemId:this.originalData[0].data.id,//
							sourceSerialNumber:original&&original.length>0?(original.length===1?original[0].label+'条':(original.length===2?
							original[1].label+'条第'+original[0].label+"款":(original.length===3?original[2].label+'条第'+original[1].label+'款第'+original[0].label+'项':
											original[3].label+'条第'+original[2].label+'款第'+original[1].label+'项第'+original[0].label+"目"))):undefined,//
							similarStandardId:58,//
							similarStandardItemId:this.similarData[0].data.id,//
							similarSerialNumber:similar&&similar.length>0?(similar.length===1?similar[0].label+'条':(similar.length===2?
									similar[1].label+'条第'+similar[0].label+"款":(similar.length===3?similar[2].label+'条第'+similar[1].label+'款第'+similar[0].label+'项':
											similar[3].label+'条第'+similar[2].label+'款第'+similar[1].label+'项第'+similar[0].label+"目"))):undefined,//
						}
					console.log(params,'params')
					
					addDrStandardItemRelation(params).then(res => {
						if (res.data.success) {
							this.$message({
								message: res.data.message,
								type: "success"
							});
							this.getDataList();
							this.addDialogClose();
						} else {
							this.$message({
								message: res.data.message,
								type: "error"
							});
						}
						this.addLoading = false
					})

				}
			})
		},
		handleDel() {
			if (!this.needData&&!this.needData.id) {
				this.$message({
					message: '请选择一条数据',
					type: "error"
				});
				return
			}
			this.$confirm('确认删除?', '提示', {
				type: 'warning'
			}).then(() => {
				deleteDrStandardItemRelation({ id: this.needData.id }).then(res => {
					if (res.data.success) {
						this.$message({
							message: res.data.message,
							type: "success"
						});
						this.getDataList();
					} else {
						this.$message({
							message: res.data.message,
							type: "error"
						});
					}
				})
			})
		},
		// 点击table某一行
		currentChange(val) {
			this.needData = val
		},
		// 分页
		handleCurrentChange(val) {
			this.pages.pageIndex = val;
			this.getDataList();
		},
		handleSizeChange(val) {
			this.pages.pageSize = val;
			this.getDataList();
		},
		// 时间格式化
		formatCreateTime: function (row, column) {
			return !row.NoticeTime || row.NoticeTime == ""
					? ""
					: util.formatDate.format(new Date(row.NoticeTime), "yyyy-MM-dd hh:mm");
		},
		rowClass({columnIndex}){
			return 'padding:8px!important;'
		},
		// 表格数据分页条数累计
		indexMethod(index) {
			var currentPage = this.pages.pageIndex
			var pageSize = this.pages.pageSize
			return (index + 1) + (currentPage - 1) * pageSize
		},
	}
}
</script>

<style lang="stylus" scoped>
</style>
